import { combineReducers } from '@reduxjs/toolkit';
import websocketReducer from '../slices/websocketSlice';
import vehicleReducer from './vehicleReducer';
import employeeReducer from './employeeReducer';
import sinisterReducer from './sinisterReducer';

const rootReducer = combineReducers({
  websocket: websocketReducer,
  vehicle: vehicleReducer,
  employee: employeeReducer,
  sinister: sinisterReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;